import React from 'react';
import { useTranslation } from 'next-i18next';
import clsx from 'clsx';
import { OrderSaleTab } from '../type';
import styles from '../products.module.scss';

const ErrorView: React.FC<{
  currentTab: OrderSaleTab;
  forTab: OrderSaleTab;
}> = ({ currentTab, forTab }) => {
  const { t } = useTranslation('orders-sales');
  const negLeft = currentTab !== forTab ? 'ordersSales__mainLeft__noItems--neg' : '';
  return (
    <div className={clsx(styles.ordersSales__mainLeft__error, styles[negLeft])}>
      {t('MY_ACCOUNT.ORDERS_SALES.ERROR.API')}
    </div>
  );
};

export default ErrorView;
